import type { FaireProductEntity } from "../../entity_types/product";

export const p_5nevqgdm7f: FaireProductEntity = {
  token: "p_5nevqgdm7f",
  type: "product",
  name: "Hooded Longline Knit Cardigan Coat",
  brandToken: "b_wrt3xtnbxw",
  brandName: "Aria Romance",
  imageUrl:
    "https://cdn.faire.com/fastly/a60a7b67119c7928831ff03b7af022f7e59244a0f32c8797fed4c047d5d9372a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1e7cec993eb51c383658967348f59aaa3e60a02e14b79a118fd6b0703f553722.jpeg",
    "https://cdn.faire.com/fastly/afdb31cd960508e816cad6cd8ef52e07fb84107532df3bb54585cd54fb5a3f31.jpeg",
    "https://cdn.faire.com/fastly/da8018c0f14630902f01b5dd8cf8c5bf3916f4b506875f07ae169a1e8e508f47.jpeg",
    "https://cdn.faire.com/fastly/9788c14155b38a93bf129c37a65085944a1d54c43b924c54a2fea8ef3389a5f7.jpeg",
    "https://cdn.faire.com/fastly/044c923f569a04b830948acdcb5fca3c733b888a214687f39561de3f8eae2104.jpeg",
    "https://cdn.faire.com/fastly/be5e7f4eb4a7284f97d43e4d034a19d7a013563e7e5766f08f00379c0d0313eb.jpeg",
    "https://cdn.faire.com/fastly/a13b4e37091fee37b2b6520cbfa6c02071dae1e51b52d6eaab2670b0dacd5344.jpeg",
    "https://cdn.faire.com/fastly/f149cc36d46196c82ce99029f98ee6396ad5a77069e0d1363e8a3b5fcfd709e7.jpeg",
    "https://cdn.faire.com/fastly/6f21e125d55645ff9b25425176bcc398ae6f0894285ead380b0d0f9981850bb6.jpeg",
    "https://cdn.faire.com/fastly/47dc3a0b81d29be73e709fc50984e81195aa966f085c23a30aaec39b933fe1bd.jpeg",
    "https://cdn.faire.com/fastly/90872a39903672a8813badfcbd83ccef1e945daa3dd40b218f09f9ee768661bd.jpeg",
    "https://cdn.faire.com/fastly/11cd4e857cf1d81d83a0beeaa80e45b940057fd27ff76a5d61258d59829cbb8c.jpeg",
    "https://cdn.faire.com/fastly/289552d577d125d2db4738090aa0305d35f549744f60901b830072c8f3396bdb.jpeg",
    "https://cdn.faire.com/fastly/55f51158d54736865a02d207837365c20960e9ac8171c17bfb8ee49795449134.jpeg",
    "https://cdn.faire.com/fastly/a8262bc59bea4f4e0eba0f474f6bf5d61434706b9cf4cb0d69252740a90d9fa2.jpeg",
    "https://cdn.faire.com/fastly/0ca264f90735a79f705efb0c47033e2ded2e1b772d17a87d18f3d61207498e28.jpeg",
    "https://cdn.faire.com/fastly/047bfba42b8466141a77754864e106f8925dd7aa5c3a68466cdd2324fea739c0.png",
  ],
  priceDollars: 47.53,
  description:
    "EXPERIENCE ULTIMATE COMFORT AND STYLE IN THIS LONGLINE HOODED CARDIGAN, FEATURING A DRAPING SILHOUETTE AND SOFT KNIT FABRIC FOR A COZY YET CHIC LOOK.\n\nIMPORTED, DESIGNED IN USA\n\nADJUSTABLE HOOD AND LONGLINE FIT\n\nDRAPING SILHOUETTE AND ALLOVER KNIT TEXTURE\n\nCONT 100% ACRYLIC\n\nModel is 5'9\" and is wearing a small. Please see size chart for detail.\n\nShips from China. All Tax and duty covered",
  tags: [],
  msrpDollars: 97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:09.744Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
